(function () {
  function initReveal() {
    var els = document.querySelectorAll('.ev-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('ev-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('ev-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initSticky() {
    var bar = document.querySelector('[data-ev-sticky]');
    var main = document.querySelector('product-form form button[type="submit"]');
    if (!bar || !main) return;
    bar.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('ev-sticky--on', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    });
    io.observe(main);
    bar.querySelector('[data-ev-sticky-buy]').addEventListener('click', function () {
      if (main.disabled) {
        main.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        main.click();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initSticky();
  });
  document.addEventListener('shopify:section:load', initReveal);
})();
